import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'last-login',
    templateUrl: 'lastLogin.component.html'
})

export class LastLoginComponent implements  OnInit {

    lastLogin: string;
    constructor(private http: HttpClient) {
    }

     ngOnInit() {
         this.getLastLogin();
    }

    public getLastLogin(): any {
        this.http.post('/dasfauthz/user/details', { responseType: 'json' })
            .subscribe((data: any) => {
               this.lastLogin = data.lastLoginTS;
            },
            error => {
                    console.error('Error in retrieving last login', error);
            });
        }
}
